import { getData, postData } from './api-base.service'

export const getTeacherProfile = (id) => {
    return getData('/TeacherCourse/GetTeacherProfile', { id: id });
}





// WEBPACK FOOTER //
// ./src/service/teacher.service.js